// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IOwnershipRoleType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    legalPriority: number;
    isRequiredLegalStatus: boolean;
    sortOrder: number;
    active: boolean;
}

export class OwnershipRoleType implements IOwnershipRoleType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public legalPriority: number;
    public isRequiredLegalStatus: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Owner OwnershipRoleType
	**/
    get Owner(): IOwnershipRoleType {
        return this.FromId(1);
    }
    /**
		Returns Lessor OwnershipRoleType
	**/
    get Lessor(): IOwnershipRoleType {
        return this.FromId(4);
    }
    /**
		Returns Lessee OwnershipRoleType
	**/
    get Lessee(): IOwnershipRoleType {
        return this.FromId(3);
    }
    /**
		Returns Lienholder OwnershipRoleType
	**/
    get Lienholder(): IOwnershipRoleType {
        return this.FromId(2);
    }
    /**
		Returns Guardian OwnershipRoleType
	**/
    get Guardian(): IOwnershipRoleType {
        return this.FromId(9);
    }
    /**
		Returns Fiduciary OwnershipRoleType
	**/
    get Fiduciary(): IOwnershipRoleType {
        return this.FromId(8);
    }
    /**
		Returns Conservator OwnershipRoleType
	**/
    get Conservator(): IOwnershipRoleType {
        return this.FromId(7);
    }
    /**
		Returns Administrator OwnershipRoleType
	**/
    get Administrator(): IOwnershipRoleType {
        return this.FromId(6);
    }
    /**
		Returns Registrant OwnershipRoleType
	**/
    get Registrant(): IOwnershipRoleType {
        return this.FromId(5);
    }
    /**
		Returns Trustee OwnershipRoleType
	**/
    get Trustee(): IOwnershipRoleType {
        return this.FromId(10);
    }
    /**
		Returns Executor OwnershipRoleType
	**/
    get Executor(): IOwnershipRoleType {
        return this.FromId(11);
    }
    /**
		Returns Division Of  OwnershipRoleType
	**/
    get DivisionOf(): IOwnershipRoleType {
        return this.FromId(12);
    }
    /**
		Returns Subsidiary Of  OwnershipRoleType
	**/
    get SubsidiaryOf(): IOwnershipRoleType {
        return this.FromId(13);
    }
    /**
		Returns DBA OwnershipRoleType
	**/
    get DBA(): IOwnershipRoleType {
        return this.FromId(14);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Owner', displayValue: 'Owner', description: 'Owner of the vehicle', legalPriority: 5, isRequiredLegalStatus: true, sortOrder: 5, active: true });
        this._dictionary.add('4', { id: 4, value: 'Lessor', displayValue: 'Lessor', description: 'The customer that is leasing the vehicle. This is the customer that holds the title.', legalPriority: 2, isRequiredLegalStatus: false, sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, value: 'Lessee', displayValue: 'Lessee', description: 'Lessee for a leased vehicle', legalPriority: 1, isRequiredLegalStatus: true, sortOrder: 15, active: true });
        this._dictionary.add('2', { id: 2, value: 'Lienholder', displayValue: 'Lienholder', description: 'Lienholder of the lien associated to the vehicle', legalPriority: 14, isRequiredLegalStatus: true, sortOrder: 20, active: true });
        this._dictionary.add('9', { id: 9, value: 'Guardian', displayValue: 'Guardian', description: 'Guardian', legalPriority: 7, isRequiredLegalStatus: true, sortOrder: 25, active: true });
        this._dictionary.add('8', { id: 8, value: 'Fiduciary', displayValue: 'Fiduciary', description: 'Fiduciary', legalPriority: 9, isRequiredLegalStatus: true, sortOrder: 30, active: true });
        this._dictionary.add('7', { id: 7, value: 'Conservator', displayValue: 'Conservator', description: 'Conservator', legalPriority: 8, isRequiredLegalStatus: true, sortOrder: 35, active: true });
        this._dictionary.add('6', { id: 6, value: 'Administrator', displayValue: 'Administrator', description: 'Administrator', legalPriority: 6, isRequiredLegalStatus: true, sortOrder: 40, active: true });
        this._dictionary.add('5', { id: 5, value: 'Registrant', displayValue: 'Registrant', description: 'The customer that is responsible for the registration.  Not usually an owner.', legalPriority: 13, isRequiredLegalStatus: false, sortOrder: 50, active: true });
        this._dictionary.add('10', { id: 10, value: 'Trustee', displayValue: 'Trustee', description: 'Trustee associated to a Trust owner', legalPriority: 3, isRequiredLegalStatus: true, sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'Executor', displayValue: 'Executor', description: 'Executor associated to an Estate owner', legalPriority: 10, isRequiredLegalStatus: true, sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'DivisionOf', displayValue: 'Division Of ', description: 'Division Of ', legalPriority: 11, isRequiredLegalStatus: false, sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'SubsidiaryOf', displayValue: 'Subsidiary Of ', description: 'Subsidiary Of ', legalPriority: 12, isRequiredLegalStatus: false, sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'DBA', displayValue: 'DBA', description: 'DBA', legalPriority: 4, isRequiredLegalStatus: true, sortOrder: 45, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IOwnershipRoleType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IOwnershipRoleType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IOwnershipRoleType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IOwnershipRoleType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IOwnershipRoleType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
